export const MemberTrainCourseEn = {
    xunjiadang:'Courses purchased',
    peixunfuwu:'Training service',
    jiage:'price',
    zhuantai:'status',
    caozuo:'operation',
    pingjiazhuantai:'Class hour'
}


// WEBPACK FOOTER //
// ./src/lang/member/MemberTrainCourse/MemberTrainCourseEn.js